module.exports = __webpack_public_path__ + "static/media/io.1b3a2e11.svg";